import React from "react";
import {
    Box,
    FormControl,
    FormLabel,
    HStack,
    IconButton,
    Image,
    Input,
    Text,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

type Props = {
    label?: string;

    previews: string[];
    onPickFiles: (files: File[]) => void;

    // ✅ optional remove support
    onRemovePreview?: (index: number) => void;

    maxFiles?: number;
    helperText?: string;
    isUploading?: boolean;
    errorMsg?: string | null;
};

export const ImageUploader: React.FC<Props> = ({
    label = "Upload Images",
    previews,
    onPickFiles,
    onRemovePreview,
    maxFiles = 12,
    helperText,
    isUploading,
    errorMsg,
}) => {
    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>

            <Input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => {
                    const picked = Array.from(e.target.files || []);
                    if (!picked.length) return;
                    onPickFiles(picked);
                    e.target.value = ""; // ✅ allow picking same file again
                }}
            />

            {helperText && (
                <Text fontSize="sm" mt={2} opacity={0.7}>
                    {helperText}
                </Text>
            )}

            {isUploading && (
                <Text fontSize="sm" mt={2} color="teal.600">
                    Uploading images...
                </Text>
            )}

            {!!errorMsg && (
                <Text fontSize="sm" mt={2} color="red.500">
                    {errorMsg}
                </Text>
            )}

            <HStack mt={3} spacing={2} overflowX="auto" py={1}>
                {previews.slice(0, maxFiles).map((src, idx) => (
                    <Box
                        key={`${src}-${idx}`}
                        borderWidth="1px"
                        borderRadius="md"
                        overflow="hidden"
                        flex="0 0 auto"
                        position="relative"
                    >
                        <Image src={src} alt={`preview-${idx}`} boxSize="72px" objectFit="cover" />

                        {onRemovePreview && (
                            <IconButton
                                aria-label="Remove image"
                                icon={<CloseIcon />}
                                size="xs"
                                colorScheme="red"
                                position="absolute"
                                top="4px"
                                right="4px"
                                onClick={() => onRemovePreview(idx)}
                            />
                        )}
                    </Box>
                ))}
            </HStack>
        </FormControl>
    );
};